import type React from "react";
import styled, { css } from "styled-components";
import { Typography } from "../Typography";

type PilledTab = {
	id: string;
	label: string;
};

type PilledTabsProps = {
	items: PilledTab[];
	activeTab: string;
	onTabChange: (tabId: string) => void;
	top?: string;
	right?: string;
	containerStyle?: React.CSSProperties;
};

const PilledTabsContainer = styled.div<{ top?: string; right?: string }>`
	align-self: flex-end;
	display: flex;
	position: absolute;
	background: var(--surface-container-lowest);
	gap: 4px;
	padding: 0.25rem;
	border-radius: 0.25rem;
	${({ top }) =>
		top &&
		css`
			top: ${top};
		`};
	${({ right }) =>
		right &&
		css`
			right: ${right};
		`};
`;

const PilledTab = styled.button<{ $isActive: boolean }>`
	padding: 0.25rem 1rem;
	position: absolute;
	background: var(--surface-container-lowest);
	border-radius: 8px;
	cursor: pointer;
	white-space: nowrap;
	border: none;
	position: relative;
	${({ $isActive }) =>
		$isActive &&
		css`
			background-color: var(--surface-container-highest);
		`};
`;

export const PilledTabs: React.FC<PilledTabsProps> = ({
	items,
	activeTab,
	onTabChange,
	top,
	right,
	containerStyle,
}) => {
	return (
		<PilledTabsContainer top={top} right={right} style={containerStyle}>
			{items.map((item) => (
				<PilledTab
					key={item.id}
					$isActive={item.id === activeTab}
					onClick={() => onTabChange(item.id)}
				>
					<Typography
						variant="paragraphSM"
						color={
							item.id === activeTab
								? "var(--text-heading)"
								: "var(--on-surface)"
						}
					>
						{item.label}
					</Typography>
				</PilledTab>
			))}
		</PilledTabsContainer>
	);
};

const Brace = styled.div`
	display: flex;
`;
